import $ from "jquery";
import "selectedIcons";
import "components/top-menu";
import "components/header";
import "components/footer";
import "components/dynamic-grid";
import "bootstrap/js/dist/alert";
import JSZip from "jszip/dist/jszip";
import "@progress/kendo-ui/js/kendo.autocomplete";
import "@progress/kendo-ui/js/kendo.grid";
import "@progress/kendo-ui/js/kendo.aspnetmvc";
import "@progress/kendo-ui/js/kendo.datepicker";
import "jquery-validation/dist/jquery.validate";
import "jquery-validation-unobtrusive/dist/jquery.validate.unobtrusive";
import "expressive-annotations-validate/dist/expressive.annotations.validate";

window.JSZip = JSZip;

$(document).ready(() => {
    $(".collapse").on("show.bs.collapse", event => {
        $(event.target).parent().find("svg:first").toggleClass("fa-minus").toggleClass("fa-plus");
    });

    $(".collapse").on("hidden.bs.collapse", event => {
        $(event.target).parent().find("svg:first").toggleClass("fa-plus").toggleClass("fa-minus");
    });
});